import {$} from './jquery-definition.js';
import 'is-in-viewport';

$( function() {
	animateInViewport();
} );

$( window ).scroll( function() {
	setTimeout( function() {
		animateInViewport();
	}, 100 );
} );

export function animateInViewport() {
	$( '.move-up-in-viewport, .move-down-in-viewport, .fade-in-in-viewport, .zoom-in-in-viewport, .active-in-viewport' ).each( function() {
		var $this = $( this );

		if ( $this.is( ':in-viewport' ) ) {
			if ( !$this.hasClass( 'active' ) && $this.hasClass( 'lazy-container' ) ) {
				var $video = $this.find( '.lazy-video' );
				var $image = $this.find( '.lazy-image' );

				if ( $video.length ) {
					var video = $video.attr( 'data-video' );
					var mime = $video.attr( 'data-mime-type' );

					$video.html( '<video class="video-cover autoplay-in-view" muted="true" playsinline="true" autoplay="true" loop="true"><source src="' + video + '" type="' + mime + '"></video>' );
				} else if ( $image.length ) {
					var image = $image.attr( 'data-image' );

					$image.css( {
						'background-image': 'url(\'' + image + '\')'
					} );
				}
			}

			$this.addClass( 'active' );
		}
	} );
}
